import { SortKey } from '../components/ApiKeysTableHeader';

// Map UI sort keys to API parameter names
export const sortKeyToApiParam: Record<SortKey, string> = {
  id: 'id',
  name: 'name',
  active: 'active',
  createDate: 'createDate',
  updateDate: 'updateDate'
};

// Format date for display
export const formatDate = (date: Date | string): string => {
  try {
    let updateDate: Date;

    if (typeof date === 'string' && date.includes('T') && date.includes('+')) {
      const [datePart, timePart] = date.split('T');
      const timeWithoutTZ = timePart.substring(0, 8);
      const safeDate = `${datePart}T${timeWithoutTZ}Z`;
      updateDate = new Date(safeDate);
    } else {
      updateDate = (typeof date === 'string' || !date) ? new Date(date) : date;
    }

    if (isNaN(updateDate.getTime())) {
      console.warn('Invalid date value:', date);
      return 'N/A';
    }

    const currentDate = new Date();
    const diffTime = currentDate.getTime() - updateDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return 'Today';
    } else if (diffDays === 1) {
      return 'Yesterday';
    } else if (diffDays < 0) {
      return 'In the future';
    } else if (diffDays < 7) {
      return `${diffDays} days ago`;
    } else if (diffDays < 30) {
      const weeks = Math.floor(diffDays / 7);
      return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
    } else if (diffDays < 365) {
      const months = Math.floor(diffDays / 30);
      return `${months} month${months > 1 ? 's' : ''} ago`;
    } else {
      const years = Math.floor(diffDays / 365);
      return `${years} year${years > 1 ? 's' : ''} ago`;
    }
  } catch (error) {
    console.error('Error formatting date:', error, date);
    return 'N/A';
  }
};
